
import MLTooltipComponent, { translateContent } from './MLTooltipComponent/MLTooltipComponent';
import FormModalPopover from './FormModalPopover/FormModalPopover';
import FacebookLike from './FacebookLike/FacebookLike';
import MLRadioTypelistComponent from './MLRadioTypelistComponent/MLRadioTypelistComponent';
import platformMessages from './PlatformMessages/platform.messages';
import QuestionSetComponent from './MLQuestionSetComponent/QuestionSetComponent';
import MLProgressModal from './MLProgressModal/MLProgressModal';
import MLAccordion from './MLAccordion/MLAccordion';
import MLInlineNotification from './MLInlineNotification/MLInlineNotification';
import MLMonthYearInput from './MLMonthYearInput/MLMonthYearInput';

const customerPlatformComponentMap = {
    MLTooltipComponent: { component: 'MLTooltipComponent' },
    FormModalPopover: { component: 'FormModalPopover' },
    FacebookLike: { component: 'FacebookLike' },
    MLRadioTypelistComponent: { component: 'MLRadioTypelistComponent' },
    QuestionSetComponent: { component: 'QuestionSetComponent' },
    MLProgressModal: { component: 'MLProgressModal' },
    MLAccordion: { component: 'MLAccordion' },
    MLInlineNotification: { component: 'MLInlineNotification' },
    MLMonthYearInput: { component: 'MLMonthYearInput' }
};

const customerPlatformComponents = {
    MLTooltipComponent,
    FormModalPopover,
    FacebookLike,
    MLRadioTypelistComponent,
    QuestionSetComponent,
    MLProgressModal,
    MLAccordion,
    MLInlineNotification,
    MLMonthYearInput
};

export {
    customerPlatformComponentMap,
    customerPlatformComponents,
    MLTooltipComponent,
    FormModalPopover,
    MLRadioTypelistComponent,
    QuestionSetComponent,
    platformMessages,
    MLProgressModal,
    translateContent,
    MLAccordion,
    MLInlineNotification,
    MLMonthYearInput
};
